import { Injectable, Injector } from '@angular/core'
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpEvent,
} from '@angular/common/http'
import { Router } from '@angular/router'
import { Observable, throwError } from 'rxjs'
import { switchMap, take, catchError } from 'rxjs/operators'
import { BasicAuthService } from '../../services/basic-auth.service'

@Injectable()
export class SpasInterceptor implements HttpInterceptor {
  private readonly authService: BasicAuthService

  public constructor(private injector: Injector, private router: Router) {
    this.authService = this.injector.get(BasicAuthService)
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.isAuthenticated().pipe(
      take(1),
      switchMap((data: boolean) => {
        let req
        if (data) {
          req = request.clone({
            headers: request.headers
              .set('Authorization', 'Bearer ' + this.authService.getToken())
              .set('Cache-Control', 'no-cache')
              .set('Pragma', 'no-cache'),
          })
        } else {
          req = request.clone({
            headers: request.headers.set('Cache-Control', 'no-cache').set('Pragma', 'no-cache'),
          })
        }

        return next.handle(req).pipe(
          catchError((error: HttpErrorResponse) => {
            const status: number = error.status
            switch (status) {
              case 401:
                this.authService.logout(true).then() // Because server already returned 401
                if (this.authService.hasADIntegration()) {
                  this.router.navigate(['windows/login']).then()
                } else {
                  this.router.navigate(['auth/login']).then()
                }
                break
            }
            return throwError(() => error)
          }),
        )
      }),
    )
  }
}
